export default __webpack_public_path__ + "static/media/login-bg.be0d9d66.jpg";